import { Helmet } from 'react-helmet-async';
import { ListVaiTroView } from 'src/sections/role/view';
import { NewVuonTrongView } from 'src/sections/vuontrong/view';

// ----------------------------------------------------------------------

export default function VuongTrongNewPage() {
  return (
    <>
      <Helmet>
        <title>Thêm vườn trồng - Hệ thống</title>
      </Helmet>
      <NewVuonTrongView />
    </>
  );
}
